var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ellipsis",class:[
    {'white-dots': _vm.white},
    {'blue-dots': _vm.blue} ]},_vm._l((4),function(item,index){return _c('div',{key:index,style:(_vm.color
      ? {backgroundColor: (_vm.color + " !important")} : {})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }